module.exports = __webpack_public_path__ + "static/media/user-edit-image-restaurant.b2de7435.svg";